import gql from 'graphql-tag';

const MUTATION_CHANGE_SEMINAR_SIGNUP = gql`
	mutation ChangeSeminarSignup($id: String!, $property: String!, $value: String) {
		changeSeminarSignup(id: $id, property: $property, value: $value)
	}
`;

export default MUTATION_CHANGE_SEMINAR_SIGNUP;